const NEW = 'NEW';
const TEST = 'TEST';
const MUTED = 'MUTED';
const STALE = 'STALE';
const MANUAL = 'MANUAL';
const LIVE = 'LIVE';
const DORMANT = 'DORMANT';

export const getPracticeStatus = (practice = {}) =>
    practice.isTestPractice
        ? TEST
        : practice.isDormant
        ? DORMANT
        : practice.ignoreStatus
        ? MANUAL
        : practice.isMuted
        ? !practice.status.partiallyActive
            ? NEW
            : MUTED
        : practice.staleValue === 1
        ? STALE
        : practice.status.partiallyActive
        ? LIVE
        : NEW;

export const getBootstrapColor = (practice = {}) => {
    const status = getPracticeStatus(practice);
    switch (status) {
        case NEW:
            return practice.isMuted ? 'warning' : 'primary';
        case TEST:
            return 'secondary';
        case MUTED:
            return 'warning';
        case STALE:
            return 'danger';
        case MANUAL:
            return 'bitwerx';
        case LIVE:
            return 'success';
        case DORMANT:
            return 'dormant';
        default:
            return 'primary';
    }
};

export const getStatusBadgeText = (practice = {}) => {
    const status = getPracticeStatus(practice);
    switch (status) {
        case NEW:
            return 'New';
        case TEST:
            return 'Test';
        case MUTED:
            return 'Muted';
        case STALE:
            return 'Stale';
        case MANUAL:
            return 'Manual';
        case LIVE:
            return 'Live';
        case DORMANT:
            return 'Dormant';
        default:
            return 'New';
    }
};

export const getStatusBackgroundClass = (practice = {}) => {
    return `bg-${getBootstrapColor(practice)}`;
};
